import { useContext } from "react";
import { InputWhite } from "@UI/New/InputWhite";
import common from '../../common.module.css';
import { ModalCopyMaterial } from "../..";

export const Name = () => {
    const { state, setFieldInState } = useContext(ModalCopyMaterial);

    return (
        <div className={common.wrapper}>
            <span>Введите название</span>
            <InputWhite 
                value={state.name} 
                onChange={(value)=>setFieldInState({field: 'name', value})} 
                placeholder='Введите название' 
                className={common.input}
            />
        </div>
    )
}
